/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { exportTargetMappingIndex } from '../../axios/exportTargetMappingIndex'
import type {
	ExportTargetMappingIndexError,
	ExportTargetMappingIndexQueryParams,
	ExportTargetMappingIndexResponse,
} from '../../types/ExportTargetMappingIndex'

export const exportTargetMappingIndexQueryKey = (params?: ExportTargetMappingIndexQueryParams) =>
	[{ url: '/export-target-mappings' }, ...(params ? [params] : [])] as const

export type ExportTargetMappingIndexQueryKey = ReturnType<typeof exportTargetMappingIndexQueryKey>

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::index */
export function exportTargetMappingIndexQueryOptions(
	params?: ExportTargetMappingIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		ExportTargetMappingIndexResponse,
		AxiosError<ExportTargetMappingIndexError>,
		ExportTargetMappingIndexResponse,
		ExportTargetMappingIndexQueryKey
	>({
		queryKey: exportTargetMappingIndexQueryKey(params),
		queryFn: ({ signal }) => exportTargetMappingIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::index */
export function useExportTargetMappingIndex<TSelectData = ExportTargetMappingIndexResponse>(
	params?: ExportTargetMappingIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ExportTargetMappingIndexResponse,
					AxiosError<ExportTargetMappingIndexError>,
					TSelectData,
					ExportTargetMappingIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ExportTargetMappingIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...exportTargetMappingIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::index */
export function useExportTargetMappingIndexSuspense<TSelectData = ExportTargetMappingIndexResponse>(
	params?: ExportTargetMappingIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ExportTargetMappingIndexResponse,
					AxiosError<ExportTargetMappingIndexError>,
					TSelectData,
					ExportTargetMappingIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ExportTargetMappingIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...exportTargetMappingIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
